// ==================================================================================
// Digital Approval System (DAS) - Reports Endpoints
// ==================================================================================
// API endpoint URL builders for the Reports module — the Workflow Summary
// dashboard under My Reports.
// ==================================================================================

import { buildEndpoint } from '../base.endpoints';

const USER_BASE = '/das/reports/user';

/**
 * Reports endpoints
 */
export const reportsEndpoints = {
  /**
   * Workflow Summary dashboard (U6) — no query params, all-time snapshot.
   * GET /das/reports/user/workflow-summary
   */
  getUserWorkflowSummary: () => buildEndpoint(`${USER_BASE}/workflow-summary`),
} as const;
